import Client from './client'

const API = {
  
  getSearchResults (search, apiKey, system, isClosed = false) {
    const lang = window.appData && window.appData.lang ? window.appData.lang : 'en'
    const baseUrl = isClosed ? 
      Client.createUrl('/search') : 
      Client.createUrl('/public-search')
    return Client.get(baseUrl, { keyword: search, key: apiKey, lang })
  },

  shareResult (email, url) {
    const page = window.appData && window.appData.shareUrl ? window.appData.shareUrl : null
    return Client.post(page, {email, url})
  }
}

export default API